import React, { useContext, useEffect, useState } from "react";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import Help from "./Help";
import Request from "common/Request";
import {
  parseHardwareChassis,
  parseHardwareCpu,
  parseHardwareMemory,
  parsePktendStatisticsExtended,
  parseFilesystem,
  ensureAsNode,
} from './api';
import {
  parseClusterHardwareId,
  parseClusterResponse,
  parseVersion,
  parseStrTable,
} from "common/api";
import View from "common/View";
import styled from "styled-components";

const getCommands = () => [
  "show system hostname detail",
  "show version",
  "show hardware chassis",
  "show hardware id",
  "show hardware cpu",
  "show hardware memory",
  "show system filesystem",
  "show pkteng statistics extended",
];

const parseClusterHostname = (response) => {
  const output = {};

  parseStrTable(response, (attrs, i) => {
    output[attrs[0]] = attrs[1];
  });

  return output;
};

function parseForBqnId(
  bqnId,
  hostnameResp,
  versionResp,
  hardwareChassisResp,
  hardwareIdResp,
  hardwareCpuResp,
  hardwareMemoryResp,
  filesystemResp,
  pktendStatisticsExtendedResp,
) {
  const hostname = parseClusterHostname(hostnameResp);
  const version = parseClusterResponse(versionResp, parseVersion);
  const chassis = parseClusterResponse(
    hardwareChassisResp,
    parseHardwareChassis
  );
  const hardwareId = parseClusterHardwareId(hardwareIdResp);
  const hardwareCpu = parseClusterResponse(hardwareCpuResp, parseHardwareCpu);
  const memory = parseClusterResponse(hardwareMemoryResp, parseHardwareMemory);
  const disk = parseClusterResponse(
    ensureAsNode(filesystemResp, bqnId),
    parseFilesystem
  );
  const dropped = parsePktendStatisticsExtended(pktendStatisticsExtendedResp);

  return Object.keys(memory)
    .filter( key => bqnId === "all" || key === bqnId.toString())
    .map( id => {
      const [vendor, product, serial] = chassis[id] ||
        ['not found', 'not found', 'not found'];
      const [cpu, cores] = hardwareCpu[id] || ['unknown', 'unknown'];
      return {
        bqnId: id,
        hostname: hostname[id] || 'unknown',
        version: version[id] || 'unknown',
        vendor,
        product,
        serial,
        hardwareId: hardwareId[id] || 'unknown',
        cpu,
        cores,
        memory: memory[id],
        disk: disk[id] || 'unknown',
        dropped,
      };
    })
  }

const Item = ({ data }) => {
  const {
    clusterStatus: { mode },
  } = useContext(BqnContext);
  return (
    <div className="row">
      {mode !== "standalone" ? <h6> BQN {data.bqnId} </h6> : null}
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div>System name</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.hostname}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div className="nowrap">BQN release</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.version}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div>Vendor</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.vendor}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div className="nowrap">Product</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.product}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div>Serial number</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.serial}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div className="nowrap">Hardware ID</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.hardwareId}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div>CPU model</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.cpu}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div className="nowrap">CPU cores</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.cores}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div>Memory size</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.memory}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div className="nowrap">Root disk partition</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-5">
          <div className="font-bold db-counters">{data.disk}</div>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-b-0">
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 margin-b-5">
          <div>Dropped pkts</div>
        </div>
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 margin-b-25">
          <div className="font-bold db-counters">{data.dropped}</div>
        </div>
      </div>
    </div>
  );
};
const ContentLayout = styled.div`
  margin: 20px;
`;

const Content = ({ data }) => data ? (
    <ContentLayout>
      {data.map((item) => (
        <Item key={item.bqnId} data={item} />
      ))}
    </ContentLayout>
  ) : null;

const doRequest = bqnId =>
  Promise.all(
    getCommands().map(cmd => ifCl.run(cmd))
  ).then(responses => ({ result: parseForBqnId(bqnId, ...responses) }));

const SystemInformation = () => {
  const {
    bqnId,
  } = useContext(BqnContext);
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);

  const doLoad = () => {
    setRequest(doRequest(bqnId));
  };

  useEffect(() => {
    doLoad();
    return actions.recv("do-load", () => doLoad());
  }, [bqnId]);

  return (
    <View title="System Information" Help={Help} className="container-lg">
      {request === null ? null :
        <Request during={request}>
          {(result) => <Content data={result.result} />}
        </Request>
      }
    </View>
  );
};

export default SystemInformation;
